export default [
  {
    path: '',
    props: true,
    component: () => import('@/views/Home')
  },
  {
    path: '/error',
    name: 'error',
    props: true,
    component: () => import('@/views/error')
  },
  {
    path: '/:hymnal',
    name: 'hymnal',
    props: true,
    component: () => import('@/views/hymnal')
  },
  {
    path: '/:hymnal/:page',
    name: 'hymn-detail',
    props: route => ({
      hymnal: route.params.hymnal,
      page: Number(route.params.page)
    }),
    component: () => import('@/components/hb/hymn-detail')
  }
]
